import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import esTranslation from './locales/es.json';

// Clear any previously stored English preference
if (typeof localStorage !== 'undefined' && localStorage.getItem('language') === 'en') {
  localStorage.setItem('language', 'es');
}

i18n
  .use(initReactI18next)
  .init({
    lng: 'es',
    fallbackLng: 'es',
    supportedLngs: ['es'],
    debug: process.env.NODE_ENV === 'development',
    resources: {
      es: {
        translation: esTranslation,
      },
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
